module.exports = __webpack_public_path__ + "c8ef927910740f2d51bcec483b6b88ad.png";